import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseDelete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#474c54",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8 8L16 16",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16 8L8 16",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCloseDelete;
